import {Box, Drawer, Grid, IconButton} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Close} from '@material-ui/icons';
import {LoadingPage} from 'components';
import useWindowSize from 'hooks/useWindowSize';
import {Show} from './utils';

const useStyles = makeStyles(theme => ({
    root: {
        width: '90%',
        padding: '1rem',
    },
}));

const findDrawerSize = width => {
    if (width < 400) {
        return width - 20;
    } else if (width < 600) {
        return width * 0.95;
    } else if (width < 800) {
        return width * 0.9;
    } else {
        return width * 0.85;
    }
};

const RightDrawer = ({
    isOpen,
    toggle,
    close,
    direction = 'column',
    forceMaxWidth = false,
    PaperProps,
    isLoading,
    ...props
}) => {
    const classes = useStyles();

    const {width} = useWindowSize();

    return (
        <Drawer
            open={isOpen}
            onClose={toggle}
            anchor='right'
            PaperProps={PaperProps}
        >
            <Show condition={isLoading}>
                <LoadingPage />
            </Show>
            <Show condition={!isLoading}>
                <Grid
                    container
                    direction={direction}
                    spacing={3}
                    className={classes.root}
                    style={{
                        maxWidth: findDrawerSize(width),
                        minWidth: forceMaxWidth
                            ? findDrawerSize(width)
                            : findDrawerSize(width) / 2,
                    }}
                >
                    <Grid item key='close'>
                        <Box textAlign='left'>
                            <IconButton onClick={close}>
                                <Close />
                            </IconButton>
                        </Box>
                    </Grid>
                    {props.children}
                </Grid>
            </Show>
        </Drawer>
    );
};

const RightDrawerCodeBox = props => {
    const {width} = useWindowSize();

    return (
        <Box maxWidth={`${findDrawerSize(width) - 20}px`}>
            <pre style={{wordWrap: 'anywhere', whiteSpace: 'pre-wrap'}}>
                {props.children}
            </pre>
        </Box>
    );
};

export default RightDrawer;
export {RightDrawer, RightDrawerCodeBox};
